<style scoped="scoped" lang="scss">
.label-table {
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
  }
  th,
  td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
    font-weight: bold;
  }
  td {
    background-color: #fff;
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/soup/record/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chutangpicihao')">
            <el-input v-model="yt.conditions.batchNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tangbaobianhao')">
            <el-input v-model="yt.conditions.toolNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_data_select type="material2" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chutangshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.soupTimeStart" :end.sync="yt.conditions.soupTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chutangshebei')">
            <yi_data_select type="equipmentAll" :queryFilter="queryFilter" :ids.sync="yt.conditions.soupEquipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')">
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.conditions.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jiaobaozhuangtai')">
            <yi_dictionary_select type="SOUP_POURING_STATUS" :ids.sync="yt.conditions.pouringStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianzhuangtai')">
            <yi_dictionary_select multiple :max="99" type="SOUP_QA_STATUS" :ids.sync="yt.conditions.qaStatusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianjieguo')">
            <yi_dictionary_select type="SOUP_QA_RESULT" :ids.sync="yt.conditions.qaResult"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')">
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.conditions.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')">
            <yi_data_select type="organization" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_cast_management_soup_record_createRecord')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowInsertDialog)">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_cast_management_soup_record_exportLabel_gld')" size="mini" type="primary" @click="exportLabel" :disabled="selectedRows.length === 0" :loading="exportLabelLoading">
          {{ $t('daochubiaoqian') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '出汤记录-导出' } }"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeShowEditDialog)" v-if="utils.checkPower('web_cast_management_soup_record_updateRecord')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('jianyandan', scope.row, '80%')">{{ $t('jianyandan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chengzhongjilu', scope.row, '80%')">{{ $t('chengzhongjilu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('touliaojilu', scope.row, '80%')">{{ $t('touliaojilu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/soup/record/delete')" v-if="utils.checkPower('web_cast_management_soup_record_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tangbaomingcheng')" required>
            <yi_data_select type="tool" :ids.sync="yt.editObj.toolId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chutangshebei')" required>
            <yi_data_select type="equipmentAll" :queryFilter="e => e.belongId == null" :ids.sync="yt.editObj.soupEquipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chutangshijian')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.soupTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('mubiaoshebei')">
            <yi_data_select type="equipmentAll" :queryFilter="e => e.belongId == null" :ids.sync="yt.editObj.targetEquipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')" required>
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.editObj.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jiaobaozhuangtai')" required>
            <yi_dictionary_select type="SOUP_POURING_STATUS" :ids.sync="yt.editObj.pouringStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianzhuangtai')" required>
            <yi_dictionary_select type="SOUP_QA_STATUS" :ids.sync="yt.editObj.qaStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianjieguo')">
            <yi_dictionary_select type="SOUP_QA_RESULT" :ids.sync="yt.editObj.qaResult"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')" required>
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.editObj.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jingzhong')">
            <el-input-number v-model="yt.editObj.netWeight" :precision="4" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('jingzhongdanwei')" :required="yt.editObj.netWeight">
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.weightUnit"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/soup/record/create/record')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tangbaomingcheng')" required>
            <yi_data_select type="tool" :ids.sync="yt.editObj.toolId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chutangshebei')" required>
            <yi_data_select type="equipmentAll" :queryFilter="e => e.belongId == null" :ids.sync="yt.editObj.soupEquipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chutangshijian')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.soupTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('mubiaoshebei')">
            <yi_data_select type="equipmentAll" :queryFilter="e => e.belongId == null" :ids.sync="yt.editObj.targetEquipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuchejian')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('liuchengzhuangtai')" required>
            <yi_dictionary_select type="SOUP_PROCESS_STATUS" :ids.sync="yt.editObj.processStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jiaobaozhuangtai')" required>
            <yi_dictionary_select type="SOUP_POURING_STATUS" :ids.sync="yt.editObj.pouringStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianzhuangtai')" required>
            <yi_dictionary_select type="SOUP_QA_STATUS" :ids.sync="yt.editObj.qaStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianjieguo')">
            <yi_dictionary_select type="SOUP_QA_RESULT" :ids.sync="yt.editObj.qaResult"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chengzhongzhuangtai')" required>
            <yi_dictionary_select type="SOUP_WEIGHING_STATUS" :ids.sync="yt.editObj.weighingStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jingzhong')">
            <el-input-number v-model="yt.editObj.netWeight" :precision="4" :step="0.1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('jingzhongdanwei')" :required="yt.editObj.netWeight != null">
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.weightUnit"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <div style="float: left;color: red;font-size: 15px;" v-show="isExistIqcOrWeighingRecord">
            <div>Tip: {{ $t('cunzaiguanliandeliuchengjilu') }}, {{ $t('wufaxiugai') }}</div>
          </div>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/soup/record/update/record')" :loading="yt.editObj.loading" type="primary" :disabled="isExistIqcOrWeighingRecord">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'jianyandan'">
        <div class="dialog-scroller">
          <iqc-inspection :soupRecordId="yt.editObj.id"></iqc-inspection>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" @click="yt.isShowEditDialog = false">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'chengzhongjilu'">
        <div class="dialog-scroller">
          <weighing-record :soupRecordId="yt.editObj.id"></weighing-record>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" @click="yt.isShowEditDialog = false">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'touliaojilu'">
        <div class="dialog-scroller">
          <feedingRecord :soupRecord="yt.editObj"></feedingRecord>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导出标签 -->
    <div class="label-tabl" v-show="false">
      <table id="label-table-id">
        <tr>
          <th colspan="2">铝液称重记录单</th>
        </tr>
        <tr>
          <th>供应商</th>
          <td>{{ labelInfo.supplier }}</td>
        </tr>
        <tr>
          <th>货品名称</th>
          <td>{{ labelInfo.productName }}</td>
        </tr>
        <tr>
          <th>司员员</th>
          <td>{{ labelInfo.operator }}</td>
        </tr>
        <tr>
          <th colspan="2">肇庆格兰达压铸科技有限公司</th>
        </tr>
        <tr>
          <th colspan="2">客户留存</th>
        </tr>
        <tr>
          <th>序号</th>
          <td>{{ labelInfo.num }}</td>
        </tr>
        <tr>
          <th>日期</th>
          <td>{{ labelInfo.date }}</td>
        </tr>
        <tr>
          <th>箱数</th>
          <td>{{ labelInfo.boxNum }}</td>
        </tr>
        <tr>
          <th>入厂时间</th>
          <td>{{ labelInfo.inTime }}</td>
        </tr>
        <tr>
          <th>出厂时间</th>
          <td>{{ labelInfo.outTime }}</td>
        </tr>
        <tr>
          <th>总重(KG)</th>
          <td>{{ labelInfo.totalWeight }}</td>
        </tr>
        <tr>
          <th>皮重(KG)</th>
          <td>{{ labelInfo.tareWeight }}</td>
        </tr>
        <tr>
          <th>净重(KG)</th>
          <td>{{ labelInfo.netWeight }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';
import XLSXStyle from 'xlsx-style';
import iqcInspection from './iqc_inspection.vue';
import weighingRecord from './weighing_record.vue';
import feedingRecord from './feeding_record.vue'
import FileSaver from 'file-saver';

export default {
  name: 'web_cast_management_soup_record_list',
  components: {
    iqcInspection,
    weighingRecord,
    feedingRecord
  },
  data() {
    return {
      exportLoading: false,
      isExistIqcOrWeighingRecord: false,
      selectedRows: [],
      labelInfo: {},
      exportLabelLoading: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return true;
          },
          width: 30
        },
        {
          label: 'chutangpicihao',
          prop: 'batchNo',
          width: 150
        },
        {
          label: 'tangbaobianhao',
          prop: 'tool.toolNo',
          width: 150
        },
        {
          label: 'chutangshebei',
          prop: 'soupEquipment.name',
          width: 150
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'wuliaoguige',
          prop: 'material.spec'
        },
        {
          label: 'chutangshijian',
          prop: 'soupTime',
          type: 'time',
          width: 180
        },
        {
          label: 'liuchengzhuangtai',
          prop: 'processStatus',
          type: 'dictionary_tag',
          key: 'SOUP_PROCESS_STATUS'
        },
        {
          label: 'jiaobaozhuangtai',
          prop: 'pouringStatus',
          type: 'dictionary_tag',
          key: 'SOUP_POURING_STATUS'
        },
        {
          label: 'zhijianzhuangtai',
          prop: 'qaStatus',
          type: 'dictionary_tag',
          key: 'SOUP_QA_STATUS'
        },
        {
          label: 'zhijianjieguo',
          prop: 'qaResult',
          type: 'dictionary_tag',
          key: 'SOUP_QA_RESULT'
        },
        {
          label: 'chengzhongzhuangtai',
          prop: 'weighingStatus',
          type: 'dictionary_tag',
          key: 'SOUP_WEIGHING_STATUS'
        },
        {
          label: 'jingzhong',
          prop: 'netWeight'
        },
        {
          label: 'jingzhongdanwei',
          prop: 'weightUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'suoshuchejian',
          prop: 'org.name',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  destroyed() {},
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 导出标签
    exportLabel() {
      if (this.selectedRows.length === 0) {
        return;
      }
      const row = this.selectedRows[0];

      const labelInfo = {
        supplier: '0',
        productName: row.material && row.material.name,
        operator: this.store.state.user.nickname,
        customer: '肇庆格兰达压铸科技有限公司',
        customerRemind: '客户留存',
        num: '1',
        date: this.dayjs(row.soupTime).format('YYYY-MM-DD'),
        boxNum: '1',
        inTime: this.dayjs(row.soupTime).format('HH:mm:ss'),
        outTime: this.dayjs(row.soupTime).format('HH:mm:ss'),
        totalWeight: '0',
        tareWeight: '0',
        netWeight: row.netWeight
      };
      this.exportLabelLoading = true;
      this.http
        .get('/web/soup/record/export/label', {
          params: {
            id: row.id
          }
        })
        .then(res => {
          const data = res.data;
          if (!data) {
            this.$message.error('没有称重信息');
            return;
          }
          labelInfo.num = data.labelNum;
          const grossWeighingRecord = data.grossWeighingRecord;
          const tareRecord = data.tareRecord;
          if (grossWeighingRecord) {
            labelInfo.inTime = this.dayjs(grossWeighingRecord.createTime).format('HH:mm:ss');
            labelInfo.totalWeight = grossWeighingRecord.weight;
          }
          if (tareRecord) {
            labelInfo.outTime = this.dayjs(tareRecord.createTime).format('HH:mm:ss');
            labelInfo.tareWeight = tareRecord.weight;
          }
          this.labelInfo = labelInfo;
          setTimeout(() => {
            // 将表格转换为工作表
            const table = document.getElementById('label-table-id');
            const worksheet = XLSX.utils.table_to_sheet(table, { row: true });
            // 设置列宽
            const wscols = [
              { wch: 12.15 }, // 第一列宽度为20
              { wch: 13.69 } // 第二列宽度为30
            ];
            worksheet['!cols'] = wscols;
            // 设置文本居中
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = range.s.r; R <= range.e.r; ++R) {
              for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell = XLSX.utils.encode_cell({ r: R, c: C });
                if (!worksheet[cell]) continue;
                if ('m/d/yy' === worksheet[cell].z) {
                  worksheet[cell].z = 'yyyy-mm-dd';
                }
                worksheet[cell].s = { alignment: { horizontal: 'center' } };
              }
            }

            // 生成Excel文件并下载
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const wbout = XLSXStyle.write(workbook, { type: 'binary' });
            const blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });
            FileSaver.saveAs(blob, `铝液称重记录单_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
          }, 300);
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.exportLabelLoading = false;
        });
    },
    // 将字符串转换为ArrayBuffer
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    // 选中行数据
    selectionChange(rows) {
      // 保证只选中一行
      if (rows.length > 1) {
        this.yt.$refs.table.toggleRowSelection(rows[0], false);
      }
      const row = rows[rows.length - 1];
      if (row) {
        this.selectedRows = [row];
      } else {
        this.selectedRows = [];
      }
    },
    // 生成并导出excel
    exportExcel() {
      this.exportLoading = true;
      const data = this.yt.list || [];
      // 筛选出表头和prop
      const columns = this.columns.filter(c => c.type !== 'slot');
      let tableFirst = columns.map(column => this.$t(column.label));
      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        for (let j = 0; j < columns.length; j++) {
          const column = columns[j];
          const value = this.utils.getObjValueByLevelString(data[i], column.prop);
          const v = this.formatValue(column, value);
          dataArr.push(v);
        }
        tableArr.push(dataArr);
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `出汤记录_导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      this.exportLoading = false;
    },
    // 导出Excel时格式化值
    formatValue(column, value) {
      if (value == null) {
        return '';
      }
      switch (column.type) {
        case 'time':
          return this.dayjs(value).format('YYYY-MM-DD HH:mm:ss');
        case 'dictionary_tag':
          return this.$t(this.$store.state.dictJson[column.key][value]);
        case 'dictionary':
          return this.$t(this.$store.state.dictJson[column.key][value]);
        default:
          return value;
      }
    },
    // 新增之前处理数据
    beforeShowInsertDialog(row) {
      row.soupTime = this.dayjs().valueOf();
      row.processStatus = '2';
      row.pouringStatus = '1';
      row.qaStatus = '1';
      row.qaResult = '1';
      row.weighingStatus = '2';
      return row;
    },
    // 编辑之前处理数据
    beforeShowEditDialog(row) {
      this.queryIsExistIqcOrWeighingRecord(row.id);
      return row;
    },
    // 打开编辑弹窗时查询此出汤记录是否存在关联质检单或称重记录
    queryIsExistIqcOrWeighingRecord(id) {
      this.http
        .get('/web/soup/record/isExistIqcOrWeighingRecord', {
          params: {
            id: id
          }
        })
        .then(res => {
          if (res.data != null) {
            this.isExistIqcOrWeighingRecord = res.data;
          }
        });
    },
    // 设备过滤器
    queryFilter(e) {
      return e.typeId === 13;
    }
  }
};
</script>
